import api from '../lib/api'
import assign from 'lodash.assign'
import QRCode from 'qrcode'
import poster from '../types/poster.types'
import global from '../types/global.types'

const name = 'poster'

export default {
  name,
  namespaced: true,
  state: {
    ready: 0,
    building: true,
    qrcodeData: '',
    posterData: '',
    url: '',
    earn: 0,
    rate: 0,
    courseId: '',
    courseName: '',
    avatar: '',
    username: '',
    templateList: [],
    selectorShow: false,
    shareText: '' // 分享文案
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    [poster.SET_POSTER_INFO] (state, data) {
      state.url = data.url
      state.earn = data.earnMoney
      state.rate = data.rate
      state.courseName = data.title
      state.courseId = data.courseId
      state.templateList = data.templateList
      state.shareText = data.text || ''
    },

    [poster.SET_USER_INFO] (state, data) {
      state.avatar = data.pic
      state.username = data.nickname
    }
  },
  actions: {
    initInfo ({ commit, dispatch, rootState: { userInfo: data } }, route) {
      return new Promise(async resolve => {
        // const { data } = await api.mine.userInfo()
        const { pic: imgSrc } = data // 原链接
        const proxySrc = imgSrc // 代理链接
          // 1. https://edu-m.wps.cn/canvas/qwps/193897001_0666018b0b43465ebc95927194079cd7?imageMogr/v2/crop/!180x180a0a0
          // => https://img.qwps.cn/193897001_0666018b0b43465ebc95927194079cd7?imageMogr/v2/crop/!180x180a0a0
          .replace('http://img.qwps.cn/', '//edu-m.wps.cn/canvas/qwps/')
          .replace('https://img.qwps.cn/', '//edu-m.wps.cn/canvas/qwps/')
          // 2. https://edu-m.wps.cn/canvas/thirdwx/mmopen/vi_32/DYAIOgq83eomvG1Aq2AryHAS4QAt6UUlOmLlrlx0W891wW4Wsd0hOtOXmibydTWOWeEd4PyOQhxmkwGds0P5QdA/132
          // => http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eomvG1Aq2AryHAS4QAt6UUlOmLlrlx0W891wW4Wsd0hOtOXmibydTWOWeEd4PyOQhxmkwGds0P5QdA/132
          .replace('http://thirdwx.qlogo.cn/', '//edu-m.wps.cn/canvas/thirdwx/')
          .replace('https://thirdwx.qlogo.cn/', '//edu-m.wps.cn/canvas/thirdwx/')
          // 3. https://edu-m.wps.cn/canvas/qlogo/qqapp/100360965/623052B9EDB707CA168999C879233224/100
          // => https://q.qlogo.cn/qqapp/100360965/623052B9EDB707CA168999C879233224/100
          .replace('http://q.qlogo.cn/', '//edu-m.wps.cn/canvas/qlogo/')
          .replace('https://q.qlogo.cn/', '//edu-m.wps.cn/canvas/qlogo/')

        data.pic = ''
        commit(poster.SET_USER_INFO, data)

        // 提前resolve, 避免头像加载时间过长(api请求base64会用很长时间)
        resolve()

        if (proxySrc === imgSrc) {
          // 未代理图片
          data.pic = await dispatch('getBase64ByApi', imgSrc)
          commit(poster.SET_USER_INFO, data)
        } else {
          // 代理图片
          const img = new Image()
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          img.crossOrigin = '*'
          img.onload = () => {
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0)

            data.pic = canvas.toDataURL('image/png')
            commit(poster.SET_USER_INFO, data)
          }
          img.onerror = async () => {
            data.pic = await dispatch('getBase64ByApi', imgSrc)
            commit(poster.SET_USER_INFO, data)
          }
          img.src = proxySrc
        }
      })
    },

    // 通过后台转base64
    async getBase64ByApi (store, imgSrc) {
      const { data } = await api.utils.url2base64(imgSrc)()

      return 'data:image/png;base64,' + data
    },

    async getToken ({ commit }, route) {
      try {
        const res = await api.distribution.get(route.query.courseId, route.query.type)()
        commit(poster.SET_POSTER_INFO, Object.assign(res.data, { courseId: route.query.courseId }))
      } catch (E) {
        commit(global.ERR, '获取Token信息出错！', { root: true })
      }
    },

    async initQrcode ({ commit, state }, index = 0) {
      return new Promise((resolve, reject) => {
        QRCode.toDataURL(state.url + `&operationType=${index}`, {
          errorCorrectionLevel: 'M',
          mode: 'alphanumeric'
        }, (err, qrcodeData) => {
          if (err) reject(err)
          else {
            commit('set', { qrcodeData, ready: 1 })
            resolve()
          }
        })
      })
    },

    // 图片跨域导致 canvas 无法正确绘制，因此这里先将跨域的图片转成 base64 后重新赋值
    async setAvatar ({ commit }, avatar) {
      commit('set', { avatar, ready: 1 })
    },

    buildPoster ({ commit }) {
      commit('set', { building: true })
    },

    updatePosterData ({ commit }, posterData) {
      commit('set', { posterData, building: false })
    },

    async init ({ dispatch }, route) {
      await dispatch('getUserInfo', null, { root: true })
      await dispatch('initInfo')
      await dispatch('getToken', route)
      await dispatch('initQrcode')
    },

    reset ({ commit }) {
      commit('set', {
        ready: 0,
        posterData: '',
        courseId: '',
        avatar: '',
        building: true,
        selectorShow: false
      })
    }
  }
}
